import { Alert, AlertDescription } from "@/components/ui/alert";

export function LegacyJournalHoldingsNote() {
  return (
    <Alert>
      <AlertDescription>
        This journal uses legacy holdings. New volumes/issues are not structured yet. Clean up
        holdings manually when ready.
      </AlertDescription>
    </Alert>
  );
}
